import { EventStatus } from '@/types/api.generated';

import { useInfiniteFilteredEntries } from './use-infinite-filtered-entries';

/**
 * Total number of live pickem entries, driving the count badge on the Live tab. Shares the
 * `filteredEntries-InProgress` query key with the Live EntriesList, so it adds no extra
 * network request — it just reads `totalItems` off the first page.
 */
export function useLiveEntriesCount(): number {
    const { data } = useInfiniteFilteredEntries({ eventStatus: EventStatus.InProgress });
    return data?.pages[0]?.totalItems ?? 0;
}
